import { render } from "./GroupPageBuilderUsers.vue?vue&type=template&id=183da4d6&scoped=true&ts=true"
import script from "./GroupPageBuilderUsers.vue?vue&type=script&lang=ts"
export * from "./GroupPageBuilderUsers.vue?vue&type=script&lang=ts"

import "./GroupPageBuilderUsers.vue?vue&type=style&index=0&id=183da4d6&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183da4d6"]])

export default __exports__